/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { GetBadgeCategoriesInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetBadgeCategoriesOkDto } from '../../src/model';
// @ts-ignore
import type { GetMyBadgesInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetMyBadgesOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAccessGuardUnauthorizedDto } from '../../src/model';
// @ts-ignore
import type { PatchNewBadgeToRegularBadgeInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { PatchNewBadgeToRegularBadgeNotFoundDto } from '../../src/model';
// @ts-ignore
import type { PatchNewBadgeToRegularBadgeOkDto } from '../../src/model';
/**
 * BadgeApi - axios parameter creator
 * @export
 */
export const BadgeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 뱃지 카테고리 전체 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeControllerGetBadgeCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/badge/category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 보유 뱃지 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeControllerGetMyBadges: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/badge/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 새로운 뱃지 최초 모달 조회 후 신규 뱃지여부 변경
         * @param {number} badgeCategoryId 뱃지 카테고리 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeControllerPatchNewBadgeToRegularBadge: async (badgeCategoryId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'badgeCategoryId' is not null or undefined
            assertParamExists('badgeControllerPatchNewBadgeToRegularBadge', 'badgeCategoryId', badgeCategoryId)
            const localVarPath = `/badge/category/{badgeCategoryId}`
                .replace(`{${"badgeCategoryId"}}`, encodeURIComponent(String(badgeCategoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BadgeApi - functional programming interface
 * @export
 */
export const BadgeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BadgeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 뱃지 카테고리 전체 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgeControllerGetBadgeCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBadgeCategoriesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgeControllerGetBadgeCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgeApi.badgeControllerGetBadgeCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 보유 뱃지 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgeControllerGetMyBadges(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyBadgesOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgeControllerGetMyBadges(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgeApi.badgeControllerGetMyBadges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 새로운 뱃지 최초 모달 조회 후 신규 뱃지여부 변경
         * @param {number} badgeCategoryId 뱃지 카테고리 id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async badgeControllerPatchNewBadgeToRegularBadge(badgeCategoryId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PatchNewBadgeToRegularBadgeOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.badgeControllerPatchNewBadgeToRegularBadge(badgeCategoryId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgeApi.badgeControllerPatchNewBadgeToRegularBadge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BadgeApi - factory interface
 * @export
 */
export const BadgeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BadgeApiFp(configuration)
    return {
        /**
         * 
         * @summary 뱃지 카테고리 전체 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeControllerGetBadgeCategories(options?: RawAxiosRequestConfig): AxiosPromise<GetBadgeCategoriesOkDto> {
            return localVarFp.badgeControllerGetBadgeCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 보유 뱃지 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeControllerGetMyBadges(options?: RawAxiosRequestConfig): AxiosPromise<GetMyBadgesOkDto> {
            return localVarFp.badgeControllerGetMyBadges(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 새로운 뱃지 최초 모달 조회 후 신규 뱃지여부 변경
         * @param {BadgeApiBadgeControllerPatchNewBadgeToRegularBadgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        badgeControllerPatchNewBadgeToRegularBadge(requestParameters: BadgeApiBadgeControllerPatchNewBadgeToRegularBadgeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PatchNewBadgeToRegularBadgeOkDto> {
            return localVarFp.badgeControllerPatchNewBadgeToRegularBadge(requestParameters.badgeCategoryId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for badgeControllerPatchNewBadgeToRegularBadge operation in BadgeApi.
 * @export
 * @interface BadgeApiBadgeControllerPatchNewBadgeToRegularBadgeRequest
 */
export interface BadgeApiBadgeControllerPatchNewBadgeToRegularBadgeRequest {
    /**
     * 뱃지 카테고리 id
     * @type {number}
     * @memberof BadgeApiBadgeControllerPatchNewBadgeToRegularBadge
     */
    readonly badgeCategoryId: number
}

/**
 * BadgeApi - object-oriented interface
 * @export
 * @class BadgeApi
 * @extends {BaseAPI}
 */
export class BadgeApi extends BaseAPI {
    /**
     * 
     * @summary 뱃지 카테고리 전체 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgeApi
     */
    public badgeControllerGetBadgeCategories(options?: RawAxiosRequestConfig) {
        return BadgeApiFp(this.configuration).badgeControllerGetBadgeCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 보유 뱃지 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgeApi
     */
    public badgeControllerGetMyBadges(options?: RawAxiosRequestConfig) {
        return BadgeApiFp(this.configuration).badgeControllerGetMyBadges(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 새로운 뱃지 최초 모달 조회 후 신규 뱃지여부 변경
     * @param {BadgeApiBadgeControllerPatchNewBadgeToRegularBadgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgeApi
     */
    public badgeControllerPatchNewBadgeToRegularBadge(requestParameters: BadgeApiBadgeControllerPatchNewBadgeToRegularBadgeRequest, options?: RawAxiosRequestConfig) {
        return BadgeApiFp(this.configuration).badgeControllerPatchNewBadgeToRegularBadge(requestParameters.badgeCategoryId, options).then((request) => request(this.axios, this.basePath));
    }
}

